module.exports = __webpack_public_path__ + "static/img/来访-2.e222ee51.png";